module.exports = __webpack_public_path__ + "static/media/bg-flora-right-desk.40973040.svg";